<template>
  <div class="Man-PneuPrincipal">
    <PageTitle icon="fa fa-gear" main="Pneus" sub="Controle de pneus" />
    <div class="Man-PneuPrincipal">
      <b-card no-body>
        <b-tabs>
          <b-tab title="Cadastro" active><PneuCadastro /></b-tab>
          <b-tab title="Fabricante"><PneuFabricante /></b-tab>
          <b-tab title="Borracha"><PneuBorracha /></b-tab>
          <b-tab title="Desenho"><PneuCarcaca /></b-tab>
          <b-tab title="Medidas"><PneuMedidas /></b-tab>
          <b-tab title="Vincular Eixo no chassi"><PneuChassiEixo /></b-tab>
          <b-tab title="Avarias"><PneuAVarias /></b-tab>
          <!--<b-tab title="Rotina" ><PneuAcao /></b-tab>    -->
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import PneuCadastro from "../pneu/PneuCadastro";
import PneuFabricante from "../pneu/PneuFabricante";
import PneuBorracha from "../pneu/PneuBorracha";
import PneuCarcaca from "../pneu/PneuCarcaca";
import PneuMedidas from "../pneu/PneuMedidas";
import PneuChassiEixo from "../pneu/PneuChassiEixo";
import PneuAVarias from "../pneu/PneuAVarias";
//import PneuAcao from '../pneu/PneuAVarias'

export default {
  name: "LinhaPrincipal",
  components: {
    PageTitle,
    PneuCadastro,
    PneuFabricante,
    PneuBorracha,
    PneuCarcaca,
    PneuMedidas,
    PneuChassiEixo,
    PneuAVarias,
  },
};
</script>

<style>
</style>







